import { useEffect, useMemo } from 'react';
import useEnterpriseProctoring from './useEnterpriseProctoring';
import { useWorkscoreStore } from '../stores/workscoreStore';

const TYPE_MAP = {
  tab_switch: 'TAB_SWITCH',
  fullscreen_exit: 'FULLSCREEN_EXIT',
  copy_paste: 'COPY_ATTEMPT',
  multiple_faces: 'WINDOW_BLUR',
  face_absent: 'WINDOW_BLUR',
  gaze_away: 'WINDOW_BLUR',
  head_down: 'WINDOW_BLUR',
  voice_detected: 'WINDOW_BLUR'
};

export default function useWorkscoreProctoring({
  slug,
  videoRef,
  onAutoSubmit,
  maxViolations = 3,
  enabled = true
}) {
  const { recordViolation } = useWorkscoreStore();

  const {
    proctoringReport,
    currentAlert,
    dismissAlert,
    violations,
    integrityScore,
    faceStatus,
    gazeStatus,
    isFullscreen,
    requestFullscreen,
    recordAnswer
  } = useEnterpriseProctoring({
    assessmentKey: slug,
    videoRef,
    enabled,
    maxViolations: 10,
    onViolation: (type) => {
      const mapped = TYPE_MAP[type] || 'WINDOW_BLUR';
      recordViolation(mapped);
    },
    onForcedSubmit: () => {
      onAutoSubmit?.();
    }
  });

  const tabSwitchViolations = Number(proctoringReport?.tab_switches || 0);

  useEffect(() => {
    if (!enabled) return;
    if (tabSwitchViolations >= maxViolations) {
      onAutoSubmit?.();
    }
  }, [enabled, maxViolations, onAutoSubmit, tabSwitchViolations]);

  const violationStats = useMemo(() => ({
    totalViolations: Number(violations || 0),
    tabSwitchViolations
  }), [tabSwitchViolations, violations]);

  return {
    proctoringReport,
    currentAlert,
    dismissAlert,
    violations,
    integrityScore,
    faceStatus,
    gazeStatus,
    isFullscreen,
    enforceFullscreen: requestFullscreen,
    recordAnswerSignal: recordAnswer,
    tabSwitchViolations: violationStats.tabSwitchViolations,
    totalViolations: violationStats.totalViolations
  };
}
